import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMenu, FiEye, FiEyeOff } = FiIcons;

const BLOCK_LABELS = {
  logo: 'Logo',
  avatar: 'Avatar',
  displayName: 'Display Name',
  bio: 'Bio'
};

function DraggableBlock({ block, onToggle }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: block.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1
  };

  return (
    <div ref={setNodeRef} style={style} className="bg-white p-4 rounded-xl border border-gray-200 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <button {...attributes} {...listeners} className="cursor-grab active:cursor-grabbing p-1 text-gray-400 hover:text-gray-600">
          <SafeIcon icon={FiMenu} size={20} />
        </button>
        <span className="font-semibold text-gray-800">{BLOCK_LABELS[block.id]}</span>
      </div>
      <button onClick={() => onToggle(block.id)} className={`p-2 rounded-lg transition-colors ${block.visible ? 'text-green-600 hover:bg-green-50' : 'text-gray-400 hover:bg-gray-50'}`}>
        <SafeIcon icon={block.visible ? FiEye : FiEyeOff} size={18} />
      </button>
    </div>
  );
}

export default function LayoutBlockManager({ blocks, onReorder, onToggle }) {
  return (
    <div className="space-y-3">
      {blocks.map(block => (
        <DraggableBlock key={block.id} block={block} onToggle={onToggle} />
      ))}
    </div>
  );
}